export const DELIVERY_ALERT_TYPES = [
  {
    value: 'incorrect_location',
    label: 'Ubicacion incorrecta',
    description: 'El cliente indica que la direccion o pin no corresponde.',
    severity: 'medium',
  },
  {
    value: 'wrong_cash_amount',
    label: 'Monto incorrecto',
    description: 'El cliente indica que debe pagar un monto diferente.',
    severity: 'medium',
  },
  {
    value: 'customer_no_answer',
    label: 'No contesta',
    description: 'El cliente no responde llamadas ni mensajes.',
    severity: 'low',
  },
  {
    value: 'customer_window_closed',
    label: 'Ventana de contacto cerrada',
    description: 'La ventana de WhatsApp cerró y la entrega sigue sin confirmación.',
    severity: 'medium',
  },
  {
    value: 'wants_open_package',
    label: 'Quiere abrir paquete',
    description: 'El cliente quiere abrir/revisar antes de pagar.',
    severity: 'medium',
  },
  {
    value: 'refuses_payment',
    label: 'Rechaza pago',
    description: 'El cliente no acepta pagar el monto indicado.',
    severity: 'high',
  },
  {
    value: 'not_at_home',
    label: 'No esta en casa',
    description: 'El cliente indica que no se encuentra en el domicilio.',
    severity: 'low',
  },
  {
    value: 'unsafe_area',
    label: 'Zona insegura',
    description: 'El conductor reporta riesgo operativo o de seguridad.',
    severity: 'high',
  },
  {
    value: 'address_incomplete',
    label: 'Direccion incompleta',
    description: 'Faltan referencias, numero, torre, piso o interior.',
    severity: 'medium',
  },
  {
    value: 'package_issue',
    label: 'Problema con paquete',
    description: 'Paquete danado, abierto, equivocado o con duda.',
    severity: 'high',
  },
  {
    value: 'recipient_changed',
    label: 'Recibe otra persona',
    description: 'Una persona distinta quiere recibir la entrega.',
    severity: 'medium',
  },
  {
    value: 'payment_transfer_pending',
    label: 'Transferencia pendiente',
    description: 'El cliente indica que transfirio, pero falta confirmar.',
    severity: 'medium',
  },
  {
    value: 'driver_action_required',
    label: 'Accion motorizado',
    description: 'Operaciones necesita que el motorizado realice una accion o confirme informacion.',
    severity: 'medium',
  },
  {
    value: 'store_action_required',
    label: 'Accion tienda',
    description: 'La tienda debe confirmar datos, autorizar una decision o apoyar la gestion.',
    severity: 'medium',
  },
  {
    value: 'provider_action_required',
    label: 'Accion proveedor',
    description: 'El proveedor debe intervenir o confirmar una decision operacional.',
    severity: 'medium',
  },
  {
    value: 'pricing_review_needed',
    label: 'Revisar precio',
    description: 'La entrega tiene precio especial, ajuste o add-on que requiere visibilidad operativa.',
    severity: 'medium',
  },
  {
    value: 'cod_risk',
    label: 'Riesgo COD',
    description: 'Existe riesgo con cobro contraentrega, monto, transferencia o conciliacion.',
    severity: 'high',
  },
  {
    value: 'delivery_priority',
    label: 'Prioridad operativa',
    description: 'Entrega marcada para seguimiento especial por operaciones.',
    severity: 'low',
  },
  {
    value: 'other',
    label: 'Otra incidencia',
    description: 'Situacion no listada.',
    severity: 'medium',
  },
];

export const ALERT_TYPE_BY_VALUE = DELIVERY_ALERT_TYPES.reduce((acc, item) => {
  acc[item.value] = item;
  return acc;
}, {});

export function getAlertLabel(type) {
  return ALERT_TYPE_BY_VALUE[type]?.label || 'Alerta de entrega';
}

export function getAlertDescription(type) {
  return ALERT_TYPE_BY_VALUE[type]?.description || '';
}
